import type { Food } from '@jungles/shared';
import type { ScanPrefill } from '../screens/FoodForm';

export type SearchFood = Food & { external?: boolean };
export interface FoodSearchResponse {
  recent: Food[];
  catalog: Food[];
  external: SearchFood[];
  externalError: string | null;
}

export function foodSelection(food: SearchFood) {
  const values = { name: food.name, brand: food.brand, barcode: food.barcode,
    kcal: food.kcal100, protein: food.p100, fat: food.f100, carbs: food.c100,
    basis: 'per100' as const };
  const prefill: ScanPrefill = { ...values, grams: 100, source: 'barcode',
    notes: 'Источник: Open Food Facts. Сверьте КБЖУ с упаковкой.' };
  return { entry: food.external ? { food: values } : { foodId: food.id }, prefill };
}
